// extracted by mini-css-extract-plugin
export default {"buttons_menu":"menu-buttons_buttons_menu__vQTkP","button_view":"menu-buttons_button_view__e839f"};